import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import Typography from "../../../../../ui/atoms/Typography"
import ExpandableMenu from "../../../../../ui/molecules/ExpandableMenu"
import { useAlgoliaSearchState } from "../../controller/state"
import DiscountFilterOptions from "../DiscountFilterOptions"

export const DiscountSidebarFilter = () => {
  const [expanded, setExpanded] = React.useState(true)

  const { getLabel } = useLabels()
  const { uiFilters } = useAlgoliaSearchState()
  const discounts = uiFilters?.discounts

  if (!discounts || discounts.filter((x) => !x.disabled).length <= 0) {
    return <></>
  }

  return (
    <ExpandableMenu
      label={
        <Typography
          variant="body1"
          weightValue={500 as any}
          textClassName="uppercase mb-2"
        >
          {getLabel("search", "discount-filter")}
        </Typography>
      }
      expanded={expanded}
      onToggle={setExpanded}
      className="mt-1"
    >
      <DiscountFilterOptions />
    </ExpandableMenu>
  )
}
